import 'magnific-popup'

export default {
	init() {

		const $otpPopup = $('#sg-nagradna-popup')


		// // check if cookie early-otp-code is set and not empty
		// const earlyOtpCode = document.cookie.split('; ').find(row => row.startsWith('early-otp-code='));
		// if (earlyOtpCode && earlyOtpCode.split('=')[1] !== '') {
		// 	return
		// }

		if ($otpPopup.length) {
			openOTPPopup()
		}

		// Function to open the modal
		function openOTPPopup() {

			// Inject CSS for mobile devices
			// const style = document.createElement('style')
			// style.innerHTML = `
			// 	@media(max-width: 767px) {
			// 		.mfp-content {
			// 			min-height: 100dvh;
			// 		}
			// 	}`
			// document.head.appendChild(style)


            // Add class to body to disable scrolling
            // document.body.classList.add('overflow-hidden')

			$.magnificPopup.open({
				items: {
					src: '#sg-nagradna-popup'
				},
				type: 'inline',
				preloader: false,
				modal: true,
				callbacks: {
                    close: function() {
                        // Remove the injected style when the popup is closed
						// document.head.removeChild(style)
						
						// Remove class from body to enable scrolling
						// document.body.classList.remove('overflow-hidden')
					},
					open: function() {
						// Will fire when this exact popup is opened
						// this - is Magnific Popup object
						// otp_form_validation()
					},
                }
			})


		}



	}
}
